import React from 'react';
import * as d3 from 'd3';

interface PieDatum {
  type: string;
  count: number;
}

interface PieChartProps {
  data: PieDatum[];
  colors: string[];
  width?: number;
  height?: number;
}

const PieChart: React.FC<PieChartProps> = ({ data, colors, width = 600, height = 400 }) => {
  const radius = Math.min(width, height) / 2 - 90;
  const pieGen = d3.pie<PieDatum>().value(d => d.count);
  const arcGen = d3.arc<d3.PieArcDatum<PieDatum>>().innerRadius(0).outerRadius(radius);

  return (
    <svg width={width} height={height} style={{ background: '#f8f8f8' }}>
      <g transform={`translate(${width / 2},${height / 2})`}>
        {pieGen(data).map((arc, i) => {
          // Position label 50px outside the arc
          const labelRadius = radius + 50;
          const angle = (arc.startAngle + arc.endAngle) / 2;
          const labelX = Math.cos(angle - Math.PI / 2) * labelRadius;
          const labelY = Math.sin(angle - Math.PI / 2) * labelRadius;
          // Line from arc edge to label
          const lineX = Math.cos(angle - Math.PI / 2) * (radius + 5);
          const lineY = Math.sin(angle - Math.PI / 2) * (radius + 5);
          return (
            <g key={arc.data.type}>
              <path d={arcGen(arc) ?? undefined} fill={colors[i % colors.length]} />
              {/* Line from arc to label */}
              <line
                x1={lineX}
                y1={lineY}
                x2={labelX}
                y2={labelY}
                stroke="#333"
                strokeWidth={1}
              />
              {/* Label outside the pie */}
              <text
                x={labelX}
                y={labelY}
                textAnchor={labelX > 0 ? 'start' : 'end'}
                alignmentBaseline="middle"
                fontSize={12}
                fill="#222"
                style={{ fontWeight: 500 }}
              >
                {arc.data.type}
              </text>
            </g>
          );
        })}
      </g>
    </svg>
  );
};

export default PieChart; 